/*
 * Bowie pre-order gift. Replaces the Stoq app.
 *
 * Keeps exactly one "FREE GIFT | Bowie Tote Bag" in the cart whenever the cart
 * contains at least one GIFT-ELIGIBLE pre-order item, and removes it when it doesn't.
 *
 * NOTE: eligibility is per VARIANT, not per product. Replacement Heads only qualifies
 * on the 3 Pack -- the 1 Pack and 2 Pack are pre-order but do NOT earn the gift.
 *
 * HISTORY
 *   -- to 9 Sep 2026 : gift was FREE GIFT | Face Cleansing Pads (variant 49234244567291, $25)
 *   9 Sep 2026       : swapped to the Bowie Tote ($30) while the limited shipment lands
 *   10 Sep 2026      : the gift was reaching the cart and the checkout but the drawer never
 *                      showed it -- the drawer had already rendered before the gift add
 *                      finished. Focal's <cart-drawer> re-renders on a delegated
 *                      "cart:refresh" event, so we fire that after every gift write.
 *                      selfDispatch guards the reconcile listener against re-entering on
 *                      our own event. Also hides the gift line's Remove link and quantity
 *                      stepper, which this script would only undo on the next reconcile.
 *
 * TO EDIT LATER:
 *   GIFT_VARIANT ............. the $0 ghost SKU variant id (BLL-GIFT-TOTE)
 *   GIFT_HANDLE .............. the ghost product handle, used to style its cart line
 *   GIFT_ELIGIBLE_VARIANTS ... variant ids that earn the free gift
 *   RETIRED_GIFT_VARIANTS .... old gift SKUs to evict from carts still holding them
 */
(function () {
  'use strict';

  var GIFT_VARIANT = 49286373310715;
  var GIFT_HANDLE = 'free-gift-bowie-tote-bag';

  var GIFT_ELIGIBLE_VARIANTS = [
    46441291677947, // Mini Kit
    46441291907323, // Complete Kit
    48423520174331  // Full Routine Kit
  ];
https://admin.shopify.com/store/bowienz/products/8801405927675
  var RETIRED_GIFT_VARIANTS = [49234244567291]; // Face Cleansing Pads

  var busy = false;
  var selfDispatch = false;
  var needsRecheck = false;

  /*
   * The gift is automatic, so its Remove link and quantity stepper are dead controls --
   * this script would put the line straight back. Hide them rather than let a customer
   * click something that visibly undoes itself.
   *
   * ".line-item" (class, not tag) matches both markups: <line-item class="line-item"> in
   * the drawer and <tr class="line-item"> on the cart page. Uses :has(), so it no-ops on
   * browsers without it -- the cart stays correct, the controls just remain visible.
   */
  (function hideGiftControls() {
    var m = '.line-item:has(a[href*="' + GIFT_HANDLE + '"])';
    var css = m + ' .line-item__remove-button,' +
              m + ' .line-item__quantity,' +
              m + ' line-item-quantity{display:none !important}';
    try {
      var style = document.createElement('style');
      style.appendChild(document.createTextNode(css));
      (document.head || document.documentElement).appendChild(style);
    } catch (e) { /* cosmetic only */ }
  })();

  function isGiftEligible(item) {
    return GIFT_ELIGIBLE_VARIANTS.indexOf(item.variant_id) !== -1;
  }

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('cart write failed');
      return response.json();
    });
  }

  /*
   * Tell the storefront the cart changed.
   *
   * On the cart PAGE a reload is the only reliable redraw. Everywhere else the drawer,
   * the cart count and the free-shipping bar all listen for "cart:refresh" delegated off
   * the root element, so one bubbling event redraws the lot without a page load.
   */
  function notifyCartChanged() {
    if (window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
      return;
    }

    selfDispatch = true;
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) { /* older browsers: the cart is still correct, only the drawer lags */ }
    setTimeout(function () { selfDispatch = false; }, 1000);
  }

  function reconcile() {
    if (busy) return;
    busy = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var qualifies = false;
        var giftLine = null;
        var staleLine = null;

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (RETIRED_GIFT_VARIANTS.indexOf(item.variant_id) !== -1) { staleLine = item; continue; }
          if (item.variant_id === GIFT_VARIANT) { giftLine = item; continue; }
          if (isGiftEligible(item)) qualifies = true;
        }

        // Clear a retired gift out of a pre-existing cart, then run again to add the new one.
        if (staleLine) {
          needsRecheck = true;
          return postCart('/cart/change.js', { id: staleLine.key, quantity: 0 })
            .then(notifyCartChanged);
        }

        if (qualifies && !giftLine) {
          return postCart('/cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: 1 }] })
            .then(notifyCartChanged);
        }

        if (!qualifies && giftLine) {
          return postCart('/cart/change.js', { id: giftLine.key, quantity: 0 })
            .then(notifyCartChanged);
        }

        if (giftLine && giftLine.quantity !== 1) {
          return postCart('/cart/change.js', { id: giftLine.key, quantity: 1 })
            .then(notifyCartChanged);
        }
      })
      .catch(function () { /* never block the storefront on a gift failure */ })
      .then(function () {
        busy = false;
        if (needsRecheck) { needsRecheck = false; setTimeout(reconcile, 250); }
      });
  }

  function scheduleReconcile() {
    if (!busy && !selfDispatch) setTimeout(reconcile, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }

  // Re-check after the theme performs any cart write.
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:added'].forEach(function (name) {
    document.addEventListener(name, scheduleReconcile);
  });

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var target = arguments[0];
      if (target && target.url) target = target.url;
      var isCartWrite =
        typeof target === 'string' &&
        (target.indexOf('/cart/add') !== -1 ||
         target.indexOf('/cart/change') !== -1 ||
         target.indexOf('/cart/update') !== -1);

      var wasBusy = busy;
      var result = nativeFetch.apply(this, arguments);

      if (isCartWrite && !wasBusy && result && typeof result.then === 'function') {
        result.then(scheduleReconcile).catch(function () {});
      }
      return result;
    };
  }
})();
